import { render, staticRenderFns } from "./SplashPage.vue?vue&type=template&id=2c1ceb8f&scoped=true&"
import script from "./SplashPage.vue?vue&type=script&lang=js&"
export * from "./SplashPage.vue?vue&type=script&lang=js&"
import style0 from "./SplashPage.vue?vue&type=style&index=0&id=2c1ceb8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ceb8f",
  null
  
)

export default component.exports